module.exports = __webpack_public_path__ + "media/packs/images/flags/CL-9fb13edced0c08664b3a6b7c1fe98229.png";